<template>
<div class="container-fluid bg-white">
	<equipment-toolbar heading="Equipment" :back-link="backLink">

		<nav-tabs v-if="hasModulePermRead('Safety')"
							:tabs="[
			{ label: 'Maintenance Schedule',    path: '/equipment/item/'+$route.params.slug+'/maintenance-schedule',      icon:'fa-calendar'},
			{ label: 'Maintenance Log',    path: '/equipment/item/'+$route.params.slug+'/log',      icon:'fa-wrench'},
			{ label: 'Parts',              path: '/equipment/item/'+$route.params.slug+'/parts',    icon:'fa-toolbox'},
			{ label: 'Location',           path: '/equipment/item/'+$route.params.slug+'/location', icon:'fa-map-marker'},
			{ label: 'Images'+numImages,   path: '/equipment/item/'+$route.params.slug+'/images',   icon:'fa-image'},
			{ label: 'Files'+numFiles,     path: '/equipment/item/'+$route.params.slug+'/files',    icon:'fa-file-image'},
			{ label: 'Forms',              path: '/equipment/item/'+$route.params.slug+'/forms',    icon:'fa-clipboard-check'}
		]">
		</nav-tabs>
	</equipment-toolbar>

	<div v-if="equipmentItem.archived == 1" class="job-status-alert alert alert-warning">
		<i class="fa fa-archive"></i>
		This equipment is archived. In order to make changes you must un-archive it
	</div>

	<collapsible-panel v-if="$route.params.tab != 'files'" panel-size="xxxl" :always-open="true">
		<template slot="panel">
			<equipment-edit-form
				:version-key="versionKey"
				:equipment-slug="$route.params.slug"
				:is-form="true"
				:includes="[
					{
						model: 'EquipmentType',
						include: [
							{
								model: 'EquipmentCategory',
								fields: ['name']
							}
						],
						fields: ['name','odo_unit']
					},
					{
						model: 'EquipmentFile',
						include: [
							{
								model: 'UploadFile',
								include: [
									{
										model: 'User',
										fields: ['first_name', 'last_name']
									}
								]
							}
						]
					},
					'TrackingDevice'
				]"
				v-on:equipmentFetched="setEquipmentItem">

				<h2>Details</h2>
			</equipment-edit-form>
		</template>

		<template v-if="$route.params.tab == 'log'" slot="main">

			<div class="d-flex flex-row align-items-center justify-content-between">

				<h2>Maintenance Log</h2>

				<div v-if="$route.params.slug != 'new' && equipmentItem.archived == 0">
					<button class="btn btn-success" v-on:click="newMaintenanceLog">
						<i class="fa fa-plus"></i>
						Add Entry
					</button>
				</div>
			</div>

			<table-list
				record-name="Maintenance Record"
				:records="mutatedLogs"
				:fields="maintenanceFields"
				:has-edit="true"
				:edit-button-text="equipmentItem.archived == 0 ? 'Edit' : 'View'"
				edit-button-icon="fa-pencil-alt"
				:other-buttons="tableButtons"
				:sortable="true"
				:has-delete="equipmentItem.archived == 0"
				delete-endpoint="EquipmentMaintenanceLog/delete"
				:hide-record-count="true"
				id-field="slug"
				v-on:modelChange="fetchMaintenanceLogs"
				v-on:edit="editMaintenanceLog">
			</table-list>
		</template>

		<template v-else-if="$route.params.tab == 'maintenance-schedule'" slot="main">
			<equipment-item-maintenance-schedule 
				:equipment-item="equipmentItem">	
			</equipment-item-maintenance-schedule>
		</template>

		<template v-else-if="$route.params.tab == 'parts'" slot="main">

			<div class="d-flex justify-content-between align-items-center">
				<h2 class="m-0">Parts</h2>
				<button type="button" class="btn btn-primary btn-sm" v-on:click="materialSelectorModalVisible = true">
					<i class="fa fa-plus"></i>
					Add Part
				</button>
			</div>

			<table-list
				record-name="Part"
				:records="equipmentMaterials"
				:fields="[
						{ label: 'Description',  key: 'description' },
						{ label: 'Part Number',  key: 'part_number',  align: 'right' }
					]"
				:sortable="true"
				:hide-record-count="true"
				:has-delete="true"
				v-on:delete="removeMaterial">
			</table-list>

		</template>

		<equipment-item-location  v-else-if="$route.params.tab == 'location'" slot="main"
			:equipment-item="equipmentItem"
			v-on:equipmentLocationChanged="setEquipmentLocation">
		</equipment-item-location >

		<template v-else-if="$route.params.tab == 'images'" slot="main">
			<h2>Images</h2>

			<image-thumb-list
				:images="mutatedEquipmentImages"
				max-size="150px"
				:show-user="true"
				v-on:rotate="rotateImage"
				v-on:deleteImg="deleteEquipmentImage">

				<div style="display: inline-block;">
					<upload-field
						style="width:150px;height: 150px;"
						:icons="['fa-plus','fa-image']"
						target="UploadImage/save"
						style-type="box"
						multiple="multiple"
						v-on:uploaded="equipmentImageUploaded($event)">
					</upload-field>
				</div>
			</image-thumb-list>
		</template>

		<template v-else-if="$route.params.tab == 'forms'" slot="main">
			<forms-tab v-if="equipmentItem && 'id' in equipmentItem && equipmentItem.id" :title="formsTabTitle" :equipment-id="equipmentItem.id"></forms-tab>
		</template>
	</collapsible-panel>

	<job-files v-else store-location="equipmentItem" :only-files="true" :parent-record-slug="$route.params.slug" parent-resource="Equipment"></job-files>

	<equipment-maintenance-log-edit-modal :record="maintenanceEditModal.record"
		:visible="maintenanceEditModal.visible"
		:equipment-item="equipmentItem"
		:readonly="equipmentItem.archived == 1"
		v-on:closeModal="maintenanceEditModal.visible = false"
		v-on:saved="fetchMaintenanceLogs">
	</equipment-maintenance-log-edit-modal>

	<material-selector-modal
		:visible="materialSelectorModalVisible"
		:only-manual="true"
		:disable-price="true"
		:disable-qty="true"
		:disable-serial-num="true"
		:disable-warranty="true"
		:expenseLogPrompt="false"
		v-on:addMaterials="addMaterials"
		v-on:closeModal="materialSelectorModalVisible = false">
	</material-selector-modal>

</div>
</template>
<script type="text/javascript">
import EquipmentToolbar from "@/pages/equipment/EquipmentToolbar"
import EquipmentEditForm from "@/components/super_components/EquipmentEditForm"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import PanelMenu from "@/components/PanelMenu"
import NavTabs from "@/layout_fragments/NavTabs"


import Field from "@/components/Field"
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Pagination from "@/components/Pagination"
import FormGroup from "@/components/FormGroup"
import UploadField from "@/components/UploadField"
import FileListItem from "@/components/FileListItem"
import FormsTab from "@/components/super_components/FormsTab";
import JobFiles from "@/pages/project/JobFiles"
import ImageThumbList from "@/components/ImageThumbList"
import MaterialSelectorModal from "@/components/super_components/MaterialSelectorModal"

import EquipmentItemMaintenanceSchedule from "./EquipmentItemMaintenanceSchedule"
import EquipmentMaintenanceLogEditModal from "@/components/super_components/EquipmentMaintenanceLogEditModal"
import EquipmentItemLocation from "@/pages/equipment/equipment_item/EquipmentItemLocation"

import FormMixins from "@/mixins/FormMixins.js"
import EquipmentMixins from "@/mixins/EquipmentMixins.js"

export default {
	name: "EquipmentItem",
	components: {
		EquipmentToolbar,
		EquipmentEditForm,
		CollapsiblePanel,
		PanelMenu,
		Field,
		TableList,
		NavTabs,
		ModalDialog,
		Pagination,
		FormGroup,
		UploadField,
		FileListItem,
		FormsTab,
		JobFiles,
		ImageThumbList,
		MaterialSelectorModal,
		EquipmentItemMaintenanceSchedule,
		EquipmentMaintenanceLogEditModal,
		EquipmentItemLocation
	},
	mixins: [EquipmentMixins,FormMixins],
	data() {
		return {
			activeTab: "Details",
			maintenanceLogs: [],
			equipmentItem: {},
			equipmentGeoData: null,
			equipmentMaterials: [],   // parsed list of material parts assigned to currnet equipment item
			versionKey: 0,  // update this to refetch the equipment
			fetchTrigger: 0, //update this to refetch child resources like files
			maintenanceFields: [
				{label: "Date",key:"maintenanceDate"},
				{label: "Work Type",key:"type"},
				{label: "Mileage/Hrs",key:"mileage_or_time"},
				{label: "Work Done",key:"workDoneShort"}
			],
			formModal: {
				visible: false,
				formRecord: null
			},
			maintenanceEditModal: {
				visible: false,
				record: {},
				editingDoneBy: false,
				updateLastServiceFields: true,
				logFiles: [],
			},
			tableButtons: [
				{
					class: "btn-light",
					text: "Print View",
					link: "/equipment/view/{?}",
					icon: "fa-eye",
					newTab: true
				}
			],
			deleteConfirmVisible: false,
			materialSelectorModalVisible: false,
		}
	},
	watch: {
		equipmentItem() {
			if ("tab" in this.$route.params && "id" in this.equipmentItem) {

				if (this.$route.params.tab == 'log')
					this.fetchMaintenanceLogs()
			}
		}
	},
	computed: {
		numImages() {
			if ('EquipmentFile' in this.$store.equipmentItem && this.$store.equipmentItem.EquipmentFile) {
				const files = this.$store.equipmentItem.EquipmentFile.filter(file => ('is_file' in file && file.is_file == 0))
				return files.length ? " ("+files.length+")" : ""
			}
			return ""
		},
		numFiles() {
			if ('EquipmentFile' in this.$store.equipmentItem && this.$store.equipmentItem.EquipmentFile) {
				const files = this.$store.equipmentItem.EquipmentFile.filter(file => ('is_file' in file && file.is_file == 1))
				return files.length ? " ("+files.length+")" : ""
			}
			return ""
		},
		mutatedEquipmentImages() {
			let vm = this

			if ('EquipmentFile' in this.equipmentItem && this.equipmentItem.EquipmentFile) {

				return this.equipmentItem.EquipmentFile
					.filter(file => 'is_file' in file && file.is_file == 0)
					.map(image => {
						image.thumbUrl = ""
						image.fullUrl = ""

						if ('UploadFile' in image && image.UploadFile) {

							if ('thumb_filename' in image.UploadFile && image.UploadFile.thumb_filename)
								image.thumbUrl = window.apiRoot+"resources/images/"+vm.$store.sessionToken+"/"+image.UploadFile.thumb_filename

							if ('filename' in image.UploadFile && image.UploadFile.filename)
								image.fullUrl = window.apiRoot+"resources/images/"+vm.$store.sessionToken+"/"+image.UploadFile.filename
						}

						return image
					})
			}

			return []
		},
		formsTabTitle() {
			if (this.equipmentItem && 'description' in this.equipmentItem)
				return 'Company Forms for ' + this.equipmentItem.description
			return 'Company Forms'
		},
		backLink() {
			if ("EquipmentType" in this.equipmentItem) {
				return "/equipment/" + this.equipmentItem.EquipmentType.EquipmentCategory.name.trim().slugify() + "/" +
						this.equipmentItem.EquipmentType.name.trim().slugify()
			}
		},
		mutatedLogs() {
			let vm = this
			return this.maintenanceLogs.map(log => {
				log.maintenanceDate = vm.formatDate(log.date_done)
				log.workDoneShort = log.work_done.substring(0,30)+"..."
				return log
			})
		}
	},
	methods: {
		setEquipmentLocation(location) {
			if (!this.equipmentItem)
				return

			Object.keys(this.equipmentItem).forEach(key => {
				if (key in location)
					this.equipmentItem[key] = location[key]
			})
		},
		saveEquipmentMaterials(mats, alertMsg=false) {
			const vm = this

			const matsJSON = JSON.stringify(mats)

			let payload = {
				id: this.equipmentItem.id,
				parts_json: matsJSON
			}

			this.postData('Equipment/save', payload).then(response => {
				if (response.success) {
					vm.materialSelectorModalVisible = false
					vm.equipmentMaterials = mats
					vm.equipmentItem.parts_json = matsJSON

					if (alertMsg)
						vm.alertSuccess(alertMsg)
				}
			})
		},
		addMaterials(mats) {

			if (!mats.length)
				return

			const allMaterials = [
				...this.equipmentMaterials,   // existing materials
				...mats                       // new materials
			]

			this.saveEquipmentMaterials(allMaterials, "Added part(s)")
		},
		removeMaterial(material, index) {
			let newMaterials = this.cloneObj(this.equipmentMaterials)
			newMaterials.splice(index, 1)
			this.saveEquipmentMaterials(newMaterials, "Removed part")
		},
		equipmentImageUploaded(response) {
			//create the record link to the service

			let vm = this

			let payload = {
				equipment_id: this.equipmentItem.id,
				file_id: response.data.id,
				is_file: 0
			}

			this.postData("EquipmentFile/save", payload, true).then(response => {
				if (response.success) {
					vm.alertSaved("Image uploaded")
					vm.versionKey += 1
				}
			})
		},
		deleteEquipmentImage(image) {
			let vm = this

			let promises = [
				this.postData("EquipmentFile/delete",{id: image.id})
			]

			Promise.all(promises).then(responses => {
				vm.versionKey += 1
			})
		},
		rotateImage(dir,image) {
			let vm = this

			let payload = {
				rotate_direction: dir,
				id: image.UploadFile.id
			}

			this.postData("UploadImage/rotate",payload).then(response => {
				image.thumbUrl = window.apiRoot+'resources/images/'+vm.$store.sessionToken+'/'+image.UploadFile.filename+"?v="+Math.random()
				vm.$forceUpdate()
			})
		},
		changeTab(tab) {
			this.activeTab = tab
		},
		editDoneBy() {
			this.editMaintenanceLog.editingDoneBy = true
			this.$forceUpdate()
		},
		setEquipmentItem(eq) {
			this.equipmentItem = eq
			this.$set(this.$store,"equipmentItem",eq)

			try {
				this.equipmentMaterials = JSON.parse(this.equipmentItem.parts_json)
			} catch {
				this.equipmentMaterials = []
			}
		},
		newMaintenanceLog() {
			this.maintenanceEditModal.visible = true
			this.maintenanceEditModal.record = {
				in_house: 0,
				LibraryUpload: [],
				work_done: "",
				type: null,
				mileage_or_time: "",
				supplier_id: null,
				date_done: null
			}
			//this.maintenanceEditModal.updateLastServiceFields = false

			this.maintenanceEditModal.editingDoneBy = true
			this.maintenanceEditModal.logFiles = []

			//if (this.$store.users.length == 0)
			//	this.fetchUsers([],false,["id","slug","first_name","last_name"])
		},
		editMaintenanceLog(record) {
			this.maintenanceEditModal.visible = true

			//this.maintenanceEditModal.payload = this.stripProperties(this.cloneObj(record),["DoneBy","fieldId","rowClasses","selected","maintenanceDate","updated_by","updated_at","created_at","workDoneShort","tenant_id","UploadImage"])
			this.maintenanceEditModal.record = record
			this.maintenanceEditModal.editingDoneBy = false

			//if (this.$store.users.length == 0)
			//	this.fetchUsers([],false,["id","slug","first_name","last_name"])
		},
		fetchMaintenanceLogFile(id) {
			// Get a single LibraryUpload
			// Used to retrieve the URL to an image after uploading it
			// to the server in the current log being edited
			let vm = this

			let params = {
				include: [
						// Who uploaded the image?
					{ model: "User", fields: ["id","first_name","last_name"] },
				]
			}

			return this.getJSON("LibraryUpload/find/"+id,params)
		},
		fetchMaintenanceLogs() {
			let vm = this

			let params = {
				filters: [
					["equipment_slug",this.$route.params.slug]
				],
				include: [
						// Who did stuff to the log last?
					{ model: "User", fields: ["first_name","last_name","id","slug"] },
				]
			}

			this.spinner(true)

			this.getJSON("EquipmentMaintenanceLog/get",params,true).then(response => {
				vm.spinner(false)
				if (response.success) {
					vm.maintenanceLogs = response.data

					if (vm.openRecordOnLoad) {

					}
				}
			})
		}
	},
	created() {
		if ("id" in this.equipmentItem && "tab" in this.$route.params) {
			if (this.$route.params.tab == 'log')
				this.fetchMaintenanceLogs()
		}
	}
}
</script>

